// var acc = document.getElementsByClassName("newdion");
// var i;

// for (i = 0; i < acc.length; i++) {
//   acc[i].addEventListener("click", function () {
//     this.classList.toggle("active");
//     var panel = this.nextElementSibling;
//     if (panel.style.display === "block") {
//       panel.style.display = "none";
//     } else {
//       panel.style.display = "block";
//     }
//   });
// };

/////////////// event tracking ////////////////

(function () {
  // Ignore these spammy events from third-party libraries
  const IGNORED_EVENTS = [
    'onsite-event-publish',
    'pre-triggering-state-update',
    'triggering-state-update',
    'slideChanged',
    '__TAG_ASSISTANT_API_MESSAGE'
  ];

  const originalDispatchEvent = EventTarget.prototype.dispatchEvent;
  EventTarget.prototype.dispatchEvent = function (event) {
    // Skip ignored events completely
    if (IGNORED_EVENTS.includes(event.type)) {
      return originalDispatchEvent.call(this, event);
    }

    // Log and track all other events
    // console.log('Event name:', event.type);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: event.type,
      ...(event.detail || {})
    });
    return originalDispatchEvent.call(this, event);
  };
})();
